import { StudioRow } from '@/components/StudioRow';
import type { Studio } from '@/types';

interface StudioListProps {
  studios: Studio[];
  onOpenStudio?: (studio: Studio) => void;
  aiIdPrefix?: string;
}

export function StudioList({ studios, onOpenStudio, aiIdPrefix = 'studio-list' }: StudioListProps) {
  if (studios.length === 0) {
    return (
      <div className="rounded-2xl border border-dashed border-slate-200 bg-slate-50 px-5 py-10 text-center text-sm text-slate-500" data-ai-id={`${aiIdPrefix}-empty-state`}>
        <span data-ai-id={`${aiIdPrefix}-empty-state-text`}>검색 결과가 없어요.</span>
      </div>
    );
  }

  return (
    <ul className="divide-y divide-slate-100 overflow-hidden rounded-2xl border border-slate-200 bg-white" data-ai-id={aiIdPrefix}>
      {studios.map((studio) => (
        <StudioRow key={studio.id} studio={studio} onOpenStudio={onOpenStudio} aiIdPrefix={`${aiIdPrefix}-item`} />
      ))}
    </ul>
  );
}
